var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"text":"","prominent":"","type":"error","icon":"mdi-cloud-alert"}},[_vm._v(" "+_vm._s(_vm.alert.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }